// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"4cd42dbb","147":"3af25ed3","177":"3ee9d896","344":"9db194af","454":"4284f726","482":"b09d44e3","539":"5bc6a3f5"}[chunkId] + ".chunk.js";
};